<div class="card-wrapper">
  <div class="heading" *ngIf="isMobile && !showOneTapPay && currency === 'INR' && type!=='recuring'">
    <h2>ENTER YOUR CARD  DETAILS</h2>
    <div class="secure">
      <i class="icon-trust"></i>
      <span>100% SECURE</span>
    </div>
  </div>

  <form [formGroup]="cardForm" (ngSubmit)="onSubmit()">

    <div *ngIf="showOneTapPay" class="otd-card-onetap">
      <div *ngIf="isMobile" class="sp-line"></div>
      <app-component-loader selector="app-otd-card-onetap" [inputs]="{lastOrderData: lastOrderData, selectetCardOpt: selectetCardOpt}" [outputs]="{onInputChange: last2InputChange, onChange: onCardOptChange, onSubmit: onOneTapSubmit}" />
    </div>

    <div class="card-fields" [hidden]="showOneTapPay && selectetCardOpt!==2">
      <!-- Card Number -->
      <mat-form-field class="full-width">
        <mat-label>Card Number</mat-label>
        <input matInput placeholder="1234 XXXX XXXX XXXX" formControlName="cardNumber" (input)="validateCardNumber($event)" (blur)="validateCardNumberOnBlur($event)" id="cc-number" type="tel" [prefix]="cardPrefix" [mask]="cardNumberMask" >
        <mat-error *ngIf="cardNumber.invalid && cardNumber.touched && !cardNumber.hasError('nosupport')">Invalid Card</mat-error>
        <mat-error *ngIf="cardNumber.hasError('nosupport')">This card is not supported</mat-error>
        <div class="{{cardDetails?.card_type}}" data-bg="/assets/images/payment/sprite-accepted-cards.png"></div>
      </mat-form-field>
      <!-- Expiry date f the card -->
      <mat-form-field *ngIf="!lastOrderInfo?.show" class="exp-date">
        <mat-label>Exp Date</mat-label>
        <input matInput placeholder="MM / YYYY" formControlName="cardExpiry" (blur)="validateCardExp($event)" id="cc-exp-date" type="tel" mask="00 / 0000" autocomplete="false">
        <mat-error *ngIf="cardExpiry.invalid && cardExpiry.touched">Invalid Date</mat-error>
      </mat-form-field><span class="space-card" *ngIf="!lastOrderInfo?.show"></span>
      <!-- CVV of the card -->
      <mat-form-field *ngIf="cardCvv && !lastOrderInfo?.show" class="cvv">
        <input matInput placeholder="CVV / CVC" formControlName="cardCvv" (blur)="validateCardCvv($event)" id="cc-cvc" type="password" [mask]="cardCvvMask" autocomplete="new-password">
        <mat-error *ngIf="cardCvv.invalid && cardCvv.touched">Invalid Secret Code</mat-error>
        <div class="cvv-icon"></div>
      </mat-form-field>
      <!-- Zipcode of the card -->
      <span *ngIf="showZip" class="space-card-zip"></span>
      <mat-form-field *ngIf="showZip && !lastOrderInfo?.show" class="Zipcode">
        <input matInput placeholder="Zipcode" formControlName="zipcode" id="cc-zip" type="text">
        <mat-error *ngIf="zipcode.hasError('required') && zipcode.touched">Field required</mat-error>
      </mat-form-field>
      <!-- Name on the card -->
      <mat-form-field [class]="[isMobile ? 'full-width' : 'half-width']">
        <input matInput placeholder="Name on Card" formControlName="nameOnCard" id="cc-name-on-card" type="text">
        <mat-error *ngIf="nameOnCard.hasError('required') && nameOnCard.touched">Field required</mat-error>
        <div class="chip-img" data-bg="/assets/images/wallets.png?w=auto"></div>
      </mat-form-field>
    </div>

    <div *ngIf="showBtn" class="btn-wrapper">
      <div [hidden]="showOneTapPay && selectetCardOpt!==2" class="note">
        <span *ngIf="type!=='recuring'"><b>Note:</b> On clicking "Contribute" button you might be taken to your bank's website for 3D secure authentication</span>
      </div>
      <div *ngIf="paymentUtil.utmProceedClicked">
        <app-utm-wallet-hundred type="payment" [donation]="(cartDetails ? cartDetails?.donated_amount: cartResponse?.donated_amount) || amount"></app-utm-wallet-hundred>
      </div>
      <app-donate-btn [label]="donateBtnLabel" [hideAmount]="hidePledgeBtnAmount" [btnClass]="btnClass" [amount]="(cartDetails ? cartDetails?.donated_amount : cartResponse?.donated_amount)|| amount" [isOrderLoading]="isOrderLoading || vars.isOrderLoading" [type]="type">
      </app-donate-btn>
      <div class="note" *ngIf="type==='recuring'"><b>Note:</b> This card will be linked to the subscription and future payments will be charged automatically. On clicking "Pledge" button you might be taken to your bank's website for 3D secure authentication.</div>
    </div>
  </form>
    <div *ngIf="showBtn" class="payment-gateways">
      <div *ngIf="type!=='recuring'">
        <span class="amex-exprs" data-bg="/assets/images/payment-modes.png?w=auto"></span>
        <span class="visa-card" data-bg="/assets/images/payment-modes.png?w=auto"></span>
        <span class="mastercard-img" data-bg="/assets/images/payment-modes.png?w=auto"></span>
        <!-- <span class="payubiz" data-bg="https://d1vdjc70h9nzd9.cloudfront.net/images/payment_gateways/payment-modes.png?w=auto"></span> -->
    </div>
  </div>
</div>
